
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 510 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003893","d":"M0 0h510v300H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 150h510v75H0z"}}),_c('path',{attrs:{"fill":"#cf2027","d":"M0 175h510v25H0z"}}),_c('g',{attrs:{"fill":"#f7d116","transform":"translate(191.25 187.5)"}},[_c('g',{attrs:{"id":"d"}},[_c('g',{attrs:{"id":"c","transform":"translate(0 -75)"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-15V0h7.5","transform":"rotate(18 0 -15)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(216)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(288)"}})]),_c('use',{attrs:{"xlink:href":"#c","y":"150"}})]),_c('use',{attrs:{"xlink:href":"#d","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#d","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#d","transform":"rotate(216)"}}),_c('use',{attrs:{"xlink:href":"#d","transform":"rotate(288)"}})])])
          )
        }
      }
    